/** @format */

import { HeroContainer } from './HeroSection.style';

import LiveEdithTextHighLighter from '../../../../liveEditHighlighterstyles/liveEdithTextHighLighter.component';
import {
  isImage,
  isVideo,
} from '../../../../utils/Helper_functions/VideoAndImage';
export default function HeroSection({ data }) {
  return (
    <HeroContainer id="sec1" $color={data.overlaytext.color}>
      <div className="HeroImage">
        {/* <LiveEditImageHighLighter
          section="sec1"
          type="image"> */}
        <div className='overlayBackground'></div>
        {data?.overlaytext?.visible && <div className='overlay'>
        <LiveEdithTextHighLighter section='sec1' type="overlaytext1">
  <div
    className='Text'
    style={{
      fontSize: 'clamp(2rem, 4vw, 3rem)', // scales between 24px and 48px
      lineHeight: '1.3',
      fontFamily: 'Tenor Sans, sans-serif',
      fontWeight: 'bold',
    }}
    dangerouslySetInnerHTML={{ __html: data?.overlaytext?.overlaytext1 }}
  ></div>
</LiveEdithTextHighLighter>

<LiveEdithTextHighLighter section='sec1' type="overlaytext2">
  <div
    className='Text'
    style={{
      fontSize: 'clamp(1rem, 2.5vw, 1.5rem)', // scales between 16px and 24px
      lineHeight: '1.4',
      fontFamily: 'Montserrat, sans-serif',
    }}
    dangerouslySetInnerHTML={{ __html: data?.overlaytext?.overlaytext2 }}
  ></div>
</LiveEdithTextHighLighter>

        </div>}
        {isImage(data?.image) ? (
          <img
            src={`/public/${data?.image}`}
            alt="HomeImage"
            loading="lazy"
            className="backgroundImage"
          />
        ) : isVideo(data?.image) ? (
          <video
            src={`/public/${data?.image}`}
            className="backgroundImage"
            autoPlay
            loop
            muted
            style={{ height: "95vh", minHeight: "56vw" }}
          />
        ) : (
          <iframe
            className="backgroundImage"
            src={`https://www.youtube.com/embed/${data?.image}?autoplay=1&mute=1&loop=1&playlist=${data?.image}&controls=0&rel=0&modestbranding=1&showinfo=0&iv_load_policy=3`}
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            style={{
              minWidth: "100%",
              objectFit: "cover",
              border: "none",
              aspectRatio: "16/9",
              height: "95vh",
              minHeight: "56vw",
            }}></iframe>
        )}
        {/* </LiveEditImageHighLighter> */}
      </div>
      <div className="hero_information">
       <LiveEdithTextHighLighter section="sec1" type="text1">
  <div
    dangerouslySetInnerHTML={{ __html: data.text1 }}
    className="sub_header"
    style={{
      fontFamily: 'Tenor Sans, sans-serif',
      fontSize: 'clamp(1.5rem, 3vw, 2.5rem)', 
      fontWeight: 400,
      lineHeight: '1.4',
      textAlign: 'center',
      color: 'black',
      paddingBottom: '15px',
    }}
  ></div>
</LiveEdithTextHighLighter>

<LiveEdithTextHighLighter section="sec1" type="text2">
  <div
    className="header"
    dangerouslySetInnerHTML={{ __html: data.text2 }}
    style={{
      fontSize: 'clamp(2rem, 4vw, 3rem)',
      fontFamily: 'Tenor Sans, sans-serif',
      textAlign: 'center',
      lineHeight: '1.5',
      color: '#333',
      fontWeight: "bold",
    }}
  ></div>
</LiveEdithTextHighLighter>

<LiveEdithTextHighLighter section="sec1" type="description">
  <div
    className="description"
    dangerouslySetInnerHTML={{ __html: data.description }}
    style={{
      fontSize: 'clamp(1rem, 2vw, 1.25rem)', // Responsive between 16px–20px
      fontFamily: 'Montserrat, sans-serif',
      lineHeight: '1.6',
      textAlign: 'center',
      color: '#444',
    }}
  ></div>
</LiveEdithTextHighLighter>

      </div>
    </HeroContainer>
  );
}
